// extracted by mini-css-extract-plugin
export default {"highlightedText":"SearchMatchText-module__highlightedText--ke3pi"};